import React from "react";

export const Team = ({ data }) => {
  return (
    <section id="team" className="team-section">
      <div className="team-container">
        <h2 className="team-title">
          NUESTRO EQUIPO <span className="underline"></span>
        </h2>

        <div className="team-grid">
          {data ? (
            data.map((member, i) => (
              <div className="team-card" key={`${member.name}-${i}`}>
                <div className="team-image-wrapper">
                  <img
                    src={member.img}
                    alt={member.name}
                    className="team-img"
                  />
                </div>
                <div className="team-content">
                  <h4>{member.name}</h4>
                  <p className="job">{member.job}</p>
                  {member.description && (
                    <p className="desc">{member.description}</p>
                  )}
                  {member.description && (
                    <strong className="desc1">{member.description1}</strong>
                  )}
                  <div className="social-icons">
                    {member.igUrl && (
                      <a
                        href={member.igUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-wrapper"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    )}
                  </div>
                  {member.description2 && (
                    <p className="desc">{member.description2}</p>
                  )}
                  {member.description2 && (
                    <strong className="desc1">{member.description3}</strong>
                  )}
                  <div className="social-icons">
                    {member.websiteUrl && (
                      <a
                        href={member.websiteUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-wrapper"
                      >
                        <img
                          src="/icons/allphotos.png"
                          alt="All Photos and Videos"
                          className="social-logo-img"
                        />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>loading...</p>
          )}
        </div>
      </div>
    </section>
  );
};
